import { Component, OnDestroy, OnInit } from '@angular/core';
import { AuthService } from 'src/service/auth';
import {BasicService} from 'src/service/basic.service';
import { Router,ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup , Validators } from '@angular/forms';
import { BRAND_ASSETS } from '../constants/branding';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit, OnDestroy {
  brand = BRAND_ASSETS;

  passwordForm:FormGroup;
  loginForm:FormGroup;
  showPassword = false;
  pwdOpen = false;
  showprogress = false;
  forgotStatus: 'form' | 'success' | 'error' = 'form';
  forgotMessage = '';
  constructor(private authService: AuthService,private activatedRoute:ActivatedRoute, private router: Router,private fb:FormBuilder,public basicService:BasicService) { 
    this.loginForm= fb.group({
      email:[this.basicService.getItem('email'),[Validators.required,this.basicService.isEmail]],
      password:[this.basicService.getItem('password'),[Validators.required,this.basicService.isEmpty]],
      remeberpassword:[true,[Validators.required,this.basicService.isEmpty]]     
      
    })
    this.passwordForm= fb.group({
      emailid:[null,[Validators.required,this.basicService.isEmpty]]      
    })
    this.loginWithDefaultCredentials()  
    
  }


  errorMsg:any = null;
  successMsg:any = null;
  success:any = null;

  ngOnInit(): void {
  }

  ngOnDestroy(): void {
    document.body.style.overflow = '';
  }

  loginWithDefaultCredentials(){
    if(this.basicService.getItem("user_data") && this.basicService.getItem("user_data")!="undefined" && this.basicService.getItem("user_data")!=""){
      let credential=this.basicService.getItem("user_data") as any;
      let data={email:credential.email,password:credential.password}
      this.basicService.showprogress=true;
      this.authService.login(data).toPromise().then((response: any) => {
        this.basicService.showprogress=false;
        if(response.status === "success"){
          this.basicService.user_data=response.user_data
          this.basicService.user_data.password=data.password
          this.basicService.setItem("user_data",this.basicService.user_data);
          this.router.navigate(['/'+this.basicService.user_data.path_name.toLowerCase()]);
        } 
      });   
    }
  }
  onSubmitPassword = () =>{
    if (!this.passwordForm.valid) {
      for (const x in this.passwordForm.controls) {
        if (this.passwordForm.controls.hasOwnProperty(x)) {
            this.passwordForm.controls[x].markAsTouched()
        }
      }
      return;
    }

    this.showprogress = true;
    this.forgotStatus = 'form';
    this.forgotMessage = '';
    const data = {
      email: this.passwordForm.controls['emailid'].value
    };
    this.authService.forgotPassword(data).toPromise().then((response: any) => {
      this.showprogress = false;
      if (response.status === 'success') {
        this.forgotStatus = 'success';
        this.forgotMessage = 'Check your inbox for the link to reset your password.';
      } else if (response.status === 'failure' && response.message === 'Email id not registred') {
        this.forgotStatus = 'error';
        this.forgotMessage = 'Incorrect email. Please check the address and try again.';
      } else {
        this.forgotStatus = 'error';
        this.forgotMessage = response?.message || 'Could not send reset instructions. Please try again.';
      }
    }).catch(() => {
      this.showprogress = false;
      this.forgotStatus = 'error';
      this.forgotMessage = 'Could not send reset instructions. Please try again.';
    });
  }
  changePassword(){
  }
  openforgot(modal?: any): void {
    this.pwdOpen = true;
    this.forgotStatus = 'form';
    this.forgotMessage = '';
    this.showprogress = false;
    this.passwordForm = this.fb.group({
      emailid: [null, [Validators.required, this.basicService.isEmpty]]
    });
    document.body.style.overflow = 'hidden';
  }

  clearForgotFeedback(): void {
    if (this.forgotStatus === 'error') {
      this.forgotStatus = 'form';
      this.forgotMessage = '';
    }
  }

  finishForgotPassword(): void {
    this.closeForgotModal();
  }

  closeForgotModal(): void {
    if (this.showprogress) {
      return;
    }
    this.pwdOpen = false;
    this.forgotStatus = 'form';
    this.forgotMessage = '';
    document.body.style.overflow = '';
  }
  onSubmit = () =>{
    if (this.loginForm.valid) {
      let data={
        email:this.loginForm.controls["email"].value,
        password:this.loginForm.controls["password"].value,
      }
      this.basicService.showprogress=true;
      this.authService.login(data).toPromise().then((response: any) => {
        this.basicService.showprogress=false;
        if(response.status === "success"){
          this.basicService.user_data=response.user_data
          this.basicService.user_data.password=data.password
          this.basicService.setItem("user_data",this.basicService.user_data);
          if(this.loginForm.controls["remeberpassword"].value){
            this.basicService.setItem('email',this.loginForm.controls["email"].value)
            this.basicService.setItem('password',this.loginForm.controls["password"].value)
          }else{
            this.basicService.setItem('email','')
            this.basicService.setItem('password','')
          }
          this.router.navigate(['/'+this.basicService.user_data.path_name.toLowerCase()]);
        } else{
          this.errorMsg = response.message;
        }
      });   
    }else{
      for (const x in this.loginForm.controls) {
        if (this.loginForm.controls.hasOwnProperty(x)) {
            this.loginForm.controls[x].markAsTouched()
        }
      }
    }
  }
}
